module.exports = __webpack_public_path__ + "media/svg/wf-db3ac768.svg";